export default __webpack_public_path__ + "images/PdfIcon.841e73808b60f48c62b5794baa4c813f.png";